import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import Product from "../../home/Products/Product";
import ProductListView from "../../home/Products/ProductListView";
import { fetchProducts, setCurrentPage } from "../../../redux/productSlice";
import { placeholder } from "../../../assets/images";
import scrollToTop from "../../../utils/toTop";
import ProductSkeleton from "../../designLayouts/skeletons/productSkeleton";

function Items({ currentItems }) {
  const viewType = useSelector((state) => state.view.viewType);
  return (
    <>
      {currentItems &&
        currentItems.map((item) => (
          <div
            key={item?.product_id}
            className={`w-full ${
              viewType === "grid" ? "flex flex-col h-full" : "flex flex-col"
            }`}
          >
            {viewType === "grid" ? (
              <Product
                _id={item?.product_id}
                sku={item?.product}
                img={item?.file_path || placeholder}
                productName={item?.name}
                price={item?.selling_price}
                disc_perc={item?.product_disc_pc}
                disc_price={item?.discounted_selling_price}
                stock={
                  Number(item?.stock?.replace(/,/g, "")) >= 0
                    ? Number(item?.stock?.replace(/,/g, ""))
                    : null
                }
                unit={item?.unit}
                curr={item?.selling_price_cur}
              />
            ) : (
              <ProductListView
                _id={item?.product_id}
                unit={item?.unit}
                sku={item?.product}
                img={item?.file_path || placeholder}
                productName={item?.name}
                price={item?.selling_price}
                disc_perc={item?.product_disc_pc}
                disc_price={item?.discounted_selling_price}
                stock={
                  Number(item?.stock?.replace(/,/g, "")) >= 0
                    ? Number(item?.stock?.replace(/,/g, ""))
                    : null
                }
                curr={item?.selling_price_cur}
              />
            )}
          </div>
        ))}
    </>
  );
}
const Pagination = () => {
  const dispatch = useDispatch();

  const viewType = useSelector((state) => state.view.viewType);
  const products = useSelector((state) => state.products.products);
  const { itemsPerPage, order } = useSelector((state) => state.products);
  const drawerOpen = useSelector((state) => state.view.drawer);
  const status = useSelector((state) => state.products.status);
  const currentPage = useSelector((state) => state.products.currentPage);
  const radioFilters = useSelector((state) => state.filters.radioGroup);
  const checkBoxFilters = useSelector((state) => state.filters.checkboxSelect);
  const rangeFilter = useSelector((state) => state.filters.priceRange);
  const searchParam = useSelector((state) => state.filters.search);
  const singleSelect = useSelector((state) => state.filters.singleSelect);

  // Dynamically calculate the page count based on the total number of products
  const pageCount = Math.ceil(products?.NumberOfRows / itemsPerPage) || 1;
  // useEffect(() => {
  //   // Dispatch action to fetch products based on the current offset
  //   dispatch(setCurrentPage(0));
  // }, [dispatch, singleSelect, itemsPerPage, radioFilters, checkBoxFilters, searchParam, order, rangeFilter]);

  useEffect(() => {
    // Dispatch action to fetch products based on the current offset
    dispatch(
      fetchProducts({
        offset: currentPage,
        limit: itemsPerPage,
        page: currentPage,
        radioFilters: radioFilters,
        checkboxFilters: checkBoxFilters,
        searchParam: searchParam,
        single: singleSelect,
        priceRange: rangeFilter,
      }),
    );
  }, [
    dispatch,
    currentPage,
    singleSelect,
    itemsPerPage,
    radioFilters,
    checkBoxFilters,
    searchParam,
    order,
    rangeFilter,
  ]);

  // useEffect(() => {
  //   if (products?.max_price !== null) {
  //     dispatch(updatePriceRange({ max_price: products?.max_price }));
  //   }
  // }, [dispatch, products?.max_price]);
  const handlePageClick = (event) => {
    scrollToTop();
    dispatch(setCurrentPage(event.selected));
  };

  if (status === "loading")
    return <SkeletonLoader itemsPerPage={itemsPerPage} />;
  if (status === "failed") throw new Error("Could not fetch products");

  return (
    <div>
      <div
        className={`${
          viewType === "grid"
            ? drawerOpen
              ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-6"
              : "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-6"
            : "flex flex-col md:gap-2"
        }`}
      >
        <Items currentItems={products?.Result} />
      </div>
      <div className="flex flex-col mdl:flex-row  justify-center mdl:justify-between items-center">
        <ReactPaginate
          nextLabel=">"
          nextClassName="text-[30px] items-center"
          previousClassName="text-[30px] items-center"
          previousLinkClassName="my-auto h-fit"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          previousLabel="<"
          pageLinkClassName="w-fit h-7 min-w-[2.5rem] md:h-9 border-[1px] border-lightColor hover:border-gray-500 duration-300 flex justify-center items-center"
          pageClassName="mx-1 md:mx-2"
          containerClassName="flex text-xs md:text-base font-semibold font-titleFont py-10 justify-center items-center" // Add items-center here
          activeClassName="bg-black text-white"
          forcePage={currentPage}
          breakLabel="..."
          breakClassName="flex justify-center items-center text-center"
          breakLinkClassName="w-7 h-7 md:w-9 md:h-9 flex justify-center items-center text-center text-gray-500"
        />
      </div>
    </div>
  );
};

export default Pagination;

const SkeletonLoader = ({ itemsPerPage }) => {
  const viewType = useSelector((state) => state.view.viewType);
  const drawerOpen = useSelector((state) => state.view.drawer);

  // Create an array of skeletons based on the number of items per page
  const skeletons = [...Array(itemsPerPage)].map((_, index) => index);

  return (
    <div
      className={`${
        viewType === "grid"
          ? drawerOpen
            ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-6"
            : "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-6"
          : "flex flex-col gap-2"
      }`}
    >
      {skeletons.map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};
